import { createSelector } from "@reduxjs/toolkit";
import { isFeatureEnabled } from "helpers/utility/utilities";
import {
  SHOW_DS_VERSION,
  ENABLE_DS_DUPLICATE,
  CVAT_INTEGRATION,
} from "helpers/constants/filters";
import { State } from "redux/store";
import { UserInfo, UserQuota } from "types";

const userState = (state: State) => {
  return state.user;
};

export const getUserInfo = createSelector(userState, (state): UserInfo => {
  return state.userInfo;
});
/**
 * @deprecated This function is depricated use the useUserConfig custom hook instead
 */
export const getUserConfig = createSelector(userState, (state) => {
  return state.userConfig;
});

export const getIsUserLoading = createSelector(userState, (state) => {
  return state.isLoading;
});

export const getIsUserConfigLoaded = createSelector(
  getUserConfig,
  (userConfig: any) => userConfig?.length > 0,
);

export const shouldShowDsVersion = createSelector(
  getUserConfig,
  (userConfig) => {
    return isFeatureEnabled(userConfig, SHOW_DS_VERSION);
  },
);

export const shouldShowDuplicateButton = createSelector(
  getUserConfig,
  (userConfig) => {
    return isFeatureEnabled(userConfig, ENABLE_DS_DUPLICATE);
  },
);

export const getUserQuota = createSelector(
  userState,
  (state): UserQuota | null => {
    return state.userQuota;
  },
);

export const getIsCVATEnabled = createSelector(getUserConfig, (userConfig) => {
  return isFeatureEnabled(userConfig, CVAT_INTEGRATION);
});

export const getIsModelsCatalogEnabled = createSelector(
  getUserConfig,
  (userConfig) => {
    return isFeatureEnabled(userConfig, "MODELS_CATALOG");
  },
);

export const getIsUserManagementEnabled = createSelector(
  getUserConfig,
  (userConfig) => {
    return isFeatureEnabled(userConfig, "USER_MANAGEMENT");
  },
);
